/** Paid or confirmed — money has moved; creator may not cancel. */
export function hasNonRefundablePayment(rows: { status: string }[]): boolean {
  return rows.some((m) => m.status === "paid" || m.status === "confirmed");
}

/** Who may cancel under current payment state. */
export function canCancelCollab(input: {
  side: "creator" | "brand" | "admin";
  milestones: { status: string }[];
  terminal?: boolean;
}): boolean {
  if (input.terminal || input.side === "admin") return false;
  if (input.side === "brand") return true;
  return !hasNonRefundablePayment(input.milestones);
}
